<template>
  <el-row :gutter="15">
    <el-col :span="6">
      <el-card
        class="text-center"
        shadow="never"
      >
        <h1>
          {{ age }}
          <small>/ days</small>
        </h1>
        <p>Asset Age</p>
      </el-card>
    </el-col>

    <el-col :span="6">
      <el-card
        class="text-center"
        shadow="never"
      >
        <h1>
          {{ inService }}
          <small>/ days</small>
        </h1>
        <p>In Service</p>
      </el-card>
    </el-col>

    <el-col :span="6">
      <el-card
        class="text-center"
        shadow="never"
      >
        <h1>
          {{ inStock }}
          <small>/ days</small>
        </h1>
        <p>In Stock</p>
      </el-card>
    </el-col>

    <el-col :span="6">
      <el-card
        class="text-center"
        shadow="never"
      >
        <h1>{{ timesAllocated }}</h1>
        <p>Times Allocated</p>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
const ONE_DAY = 24 * 60 * 60 * 1000

export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  computed: {
    age () {
      const created = new Date(this.asset.created_at)
      const now = new Date()

      return Math.round(Math.abs((created - now) / ONE_DAY))
    },
    inService () {
      let days = 0

      this
        .asset
        .events
        .map((event, index, events) => {
          if (event.type === 'allocate') {
            const allocation = new Date(event.created_at)
            const next = (typeof events[index + 1] !== 'undefined' ? new Date(events[index + 1].created_at) : new Date())

            days += Math.round(Math.abs((allocation - next) / ONE_DAY))
          }
        })

      return days
    },
    inStock () {
      return this.age - this.inService
    },
    timesAllocated () {
      let allocations = 0

      this
        .asset
        .events
        .map(event => {
          if (event.type === 'allocate') {
            allocations++
          }
        })

      return allocations
    }
  }
}
</script>
